module.exports = __webpack_public_path__ + "img/19.468ae56b.webp";